import { createEaterAuthTransport } from "./EaterAuthTransport";
// Module state rather than a DI singleton: Pendolino's eager bundle reads it without the
// container, and webpack shares the one module instance with the lazy chunks.
// The cookie is HttpOnly, so only Nova can tell. A failed read counts as signed out.
let eater = null;
let read = null;
const listeners = new Set();
export function isEaterSignedIn() {
    return eater !== null;
}
export function onEaterSignedInChange(listener) {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}
/** Asks Nova for the session, once per page. */
export function readEaterSession(locale) {
    if (read === null)
        read = createEaterAuthTransport(locale)
            .session()
            .then((result) => {
            if (result.ok)
                setEater(result.value);
        });
    return read;
}
export function rememberEaterSignedIn(signedIn) {
    setEater(signedIn);
}
export function signOutEater(locale) {
    return createEaterAuthTransport(locale)
        .signOut()
        .then(() => setEater(null));
}
function setEater(next) {
    const was = isEaterSignedIn();
    eater = next;
    if (was !== isEaterSignedIn())
        listeners.forEach((listener) => listener(isEaterSignedIn()));
}
